/* t3p-depot (15 Oct 2026): postcode -> nearest Mainfreight depot finder + map reveal.
   Data: assets/t3p-depots.txt (built by scripts/depot_visuals.py). */
(function () {
  var cache = {};
  function load(src) {
    if (!cache[src]) {
      cache[src] = fetch(src).then(function (r) { return r.text(); }).then(function (t) {
        var D = [], P = {};
        t.split('\n').forEach(function (l) {
          if (!l || l.charAt(0) === '#') return;
          var p = l.split('|');
          if (p[0] === 'D') { D[+p[1]] = { name: p[2], addr: p[3], sub: p[4], state: p[5], pc: p[6] }; }
          else { P[p[0]] = { i: +p[1], km: p[2] ? +p[2] : null }; }
        });
        return { D: D, P: P };
      });
    }
    return cache[src];
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function render(out, data, pc) {
    var hit = data.P[pc];
    if (!/^\d{4}$/.test(pc)) { out.innerHTML = 'Enter a 4-digit postcode.'; return 'invalid'; }
    if (!hit) { out.innerHTML = 'We couldn\'t find that postcode. Try a nearby one, or call 1300 000 171.'; return 'unknown'; }
    if (hit.i < 0) {
      out.innerHTML = '<b>Mainfreight has depots in Tasmania and the NT.</b><span class="t3p-dfind__note">Choose depot collection at checkout and we\'ll confirm your nearest one when you order.</span>';
      return 'tas_nt';
    }
    var d = data.D[hit.i];
    var html = '<b>' + esc(d.name) + '</b>' + esc(d.addr) + ', ' + esc(d.sub) + ' ' + esc(d.state) + ' ' + esc(d.pc) +
      ' <span class="t3p-dfind__km">&middot; about ' + hit.km + ' km from you</span>';
    var sydney = (d.pc === '2170' || d.pc === '2766') && hit.km <= 45;
    if (sydney) {
      html += '<span class="t3p-dfind__note">In Sydney, home delivery is $97 for most suburbs.</span>';
    } else if (hit.km > 100) {
      html += '<span class="t3p-dfind__note">That\'s a fair drive. We\'ll check with you after you order in case there\'s a closer option.</span>';
    } else {
      html += '<span class="t3p-dfind__note">$275 flat. Choose "Collect from your nearest Mainfreight depot" at checkout.</span>';
    }
    out.innerHTML = html;
    return sydney ? 'sydney' : (hit.km > 100 ? 'far' : 'found');
  }
  function initFinder(form) {
    if (form.__t3p) return; form.__t3p = 1;
    var input = form.querySelector('input'), out = form.querySelector('[data-t3p-depot-out]'), src = form.getAttribute('data-src');
    input.addEventListener('focus', function () { load(src); }, { once: true });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 4); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = input.value.trim();
      out.innerHTML = 'Finding your depot&hellip;';
      load(src).then(function (data) {
        var res = render(out, data, pc);
        if (typeof gtag === 'function') { try { gtag('event', 'cdo_depot_finder', { result: res, state_prefix: pc.charAt(0) }); } catch (er) {} }
      }).catch(function () { out.innerHTML = 'Couldn\'t load the depot list. Call 1300 000 171 and we\'ll help.'; });
    });
  }
  function initMap(fig) {
    if (fig.__t3p) return; fig.__t3p = 1;
    if (!('IntersectionObserver' in window)) { fig.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { fig.classList.add('is-on'); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(fig);
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-t3p-depot-finder]'), initFinder);
    Array.prototype.forEach.call(document.querySelectorAll('[data-t3p-depot-map]'), initMap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
